module.exports = __webpack_public_path__ + "img/PEUGEOT.6836df27.webp";